var render, staticRenderFns
import script from "./-MyHotelLocalNavi.tsx?vue&type=script&lang=js&"
export * from "./-MyHotelLocalNavi.tsx?vue&type=script&lang=js&"
import style0 from "./MyHotelLocalNavi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports